module.exports = __webpack_public_path__ + "static/media/compact.c9a41ce0.svg";